import { render, staticRenderFns } from "./CompanyPreviewCompanyInfoSp.vue?vue&type=template&id=31ad521e&scoped=true"
import script from "./CompanyPreviewCompanyInfoSp.vue?vue&type=script&lang=js"
export * from "./CompanyPreviewCompanyInfoSp.vue?vue&type=script&lang=js"
import style0 from "./CompanyPreviewCompanyInfoSp.vue?vue&type=style&index=0&id=31ad521e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad521e",
  null
  
)

export default component.exports